import React, { useState, useEffect, useRef, Fragment } from "react";
import { GripVertical, Palette, X, Plus, ChevronDown, ChevronUp, Circle } from "lucide-react";
import useClickOutside from "../../../hooks/Screen/useClickOutside";
import useKeyboardShortcuts from "../../../hooks/KeysHandle/useKeyboardShortcuts";
import FloatingList from "../../UniversalComponents/FloatingElement";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../../utils/alertSlice";
import { ReactComponent as DeleteIcon } from "../../../assets/images/CrossInActive.svg";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";

const ChoiceField = ({
  setExtraFieldData,
  extraFieldData,
  /* setInputValue,
  inputValue, */
  setShadowColor,
  shadowColor,
  handleAddOption,
  setInputVisible,
  InputVisible,
  allowMultiple,
  setAllowMultiple,
  EditFieldData,
  setIsEmptyOption,
  isEmptyOption,
  inputValue,
  setInputValue,
  removeChoiceApi = null,
  handleFieldOptionUpdate,
  handleFieldOptionAdd,
  isTagsField = false,
}) => {
  const [addOptionEnabled, setAddOptionEnabled] = useState(true);
  const [colorpalette, setColorpalette] = useState(null);
  const [editFieldOption, setEditFieldOption] = useState(null);
  const [isColorSelected, setIsColorSelected] = useState(true);
  const [editValue, setEditValue] = useState({
    value: "",
    color_code: "#87CEEB",
  });

  const [showPalette, setShowPalette] = useState(false);
  const inputRef = useRef(null);
  const nameInputRef = useRef(null);
  const listRef = useRef(null);
  /* const choicestemp = [
    { id: "1", name: "Choice 1", color: "FF0000", bg: "rgba(255, 0, 0, 0.10)" },
    { id: "2", name: "Choice 2", color: "4E8D01", bg: "rgba(78, 141, 1, 0.10)" },
    { id: "3", name: "Choice 3", color: "D67D00", bg: "rgba(214, 125, 0, 0.10)" },
  ]; */

  const [choices, setChoices] = useState([]);

  const [isColoredChoice, setIsColoredChoice] = useState(true);
  const [addMore, setAddMore] = useState(false);
  const [selectedDisplay, setSelectedDisplay] = useState("dropdown");

  const [openPaletteId, setOpenPaletteId] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  // const [inputValue, setInputValue] = useState("");
  const [editingChoiceId, setEditingChoiceId] = useState(null);
  const [editingChoiceValue, setEditingChoiceValue] = useState("");
  const [selectedColor, setSelectedColor] = useState("#5F5E52");
  // const [selectedColor, setSelectedColor] = useState("#38383833");

  // const inputRef = useRef(null)

  const isAddMode = !Boolean(EditFieldData);
  const isColoredEdit = EditFieldData?.field_options?.some((choice) => choice.color_code);

  const dispatch = useDispatch();
  const handleColorpalette = (index, cpid) => {
    setColorpalette(index);
    setShowPalette(true);
    setOpenPaletteId(cpid);
  };

  const colorcloseoutsideclick = useClickOutside(() => {
    setColorpalette(null);
    setShowPalette(false);
  });

  const colors = [
    "#782AEE",

    "#DB4A6B",

    "#7A518E",

    "#C46D3A",

    "#E38BAB",

    "#5F5E52",

    "#813B3B",

    "#99031C",

    "#005D85",

    "#731B5B",

    "#DF2982",

    "#949E26",

    "#817D02",

    "#310082",

    "#9A0D94",

    "#310082",

    "#ED592E",

    "#3DB22A",

    "#2F18DB",

    "#164A79",

    "#9B6F00",

    "#007E9A",

    "#134E30",

    "#EF4444",

    "#8C7A75",

    "#65657F",

    "#80703F",

    "#D47A46",

    "#248B5B",

    "#26364C",
  ];

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // const handleColorClick = (color, choiceId) => {
  //   if (choiceId) {
  //     setSelectedColor(color);
  //   }

  //   const updatedChoice = extraFieldData?.field_options?.map((choice, index) => {
  //     if (index === openPaletteId) {
  //       return {
  //         ...choice,
  //         color_code: color,
  //       };
  //     }
  //     return choice;
  //   });
  //   setExtraFieldData((prevState) => ({
  //     ...prevState,
  //     field_options: updatedChoice,
  //   }));

  //   setShowPalette(false);
  // };

  const handleColorClick = (color, choiceId) => {
    // console.log(color, choiceId, index, "color, choiceId, index")
    if (choiceId) {
      setSelectedColor(color);
    }

    const updatedChoice = extraFieldData?.field_options?.map((choice, indexId) => {
      if (indexId === openPaletteId) {
        const updated = { ...choice };
        if (isColoredChoice) {
          updated.color_code = color;
        } else {
          delete updated.color_code;
        }
        return updated;
      }
      return choice;
    });

    console.log(updatedChoice, "updatedChoice", color, openPaletteId);

    setExtraFieldData((prevState) => ({
      ...prevState,
      field_options: updatedChoice,
    }));

    setShowPalette(false);
    // handleSaveEditChoice(index);
  };

  // Add new choice
  // const addChoice = () => {
  //   if (inputValue.trim()) {
  //     const existingChoice = extraFieldData?.field_options?.find(
  //       (choice) => choice.value.toLowerCase() === inputValue.trim().toLowerCase()
  //     );

  //     if (existingChoice) {
  //       // If the name already exists, show an alert
  //       dispatch(pushAlert({ type: "danger", message: "Choice already exists", visible: true }));
  //     } else {
  //       // If the name doesn't exist, add the new choice to the list
  //       const Color = selectedColor;
  //       const newChoice = {
  //         id: `${choices.length + 1}`,
  //         name: inputValue.trim(),
  //         color: `${Color}`,
  //         bg: `${Color}33`,
  //       };

  //       const extrafieldNewChoice = {
  //         value: newChoice.name,
  //         ...(isColorSelected && { color_code: newChoice.color }),
  //       };
  //       // setChoices((prevChoices) => [...prevChoices, newChoice]);
  //       setInputValue(""); // Reset the input field

  //       setExtraFieldData((previous) => ({
  //         ...previous,
  //         field_options: [...(previous.field_options || []), { ...extrafieldNewChoice }],
  //       }));
  //       console.log(newChoice, extraFieldData.field_options, "allchoices");
  //     }
  //   }
  //   const colorIndex = colors.indexOf(selectedColor);
  //   setSelectedColor(colorIndex + 1 === colors.length ? colors[0] : colors[colorIndex + 1]);

  //   if (nameInputRef?.current) {
  //     console.log(nameInputRef.current, "nameinputref");
  //     nameInputRef.current.focus();
  //   }
  // };

  const addChoice = () => {
    if (inputValue.trim()) {
      const existingChoice = extraFieldData?.field_options?.find(
        (choice) => choice.value.toLowerCase() === inputValue.trim().toLowerCase()
      );

      if (existingChoice) {
        dispatch(pushAlert({ type: "danger", message: "Choice already exists", visible: true }));
      } else {
        const newChoice = {
          id: `${(extraFieldData?.field_options?.length || 0) + 1}`,
          name: inputValue.trim(),
          color: selectedColor,
          bg: `${selectedColor}33`,
        };

        const extrafieldNewChoice = {
          value: newChoice.name,
          // In add mode, include color_code if isColorSelected is true
          // In edit mode, include color_code only if isColoredEdit is true
          ...(isAddMode && isColorSelected && { color_code: newChoice.color }),
          ...(!isAddMode && isColoredEdit && { color_code: newChoice.color }),
        };

        setExtraFieldData((previous) => ({
          ...previous,
          field_options: [...(previous.field_options || []), { ...extrafieldNewChoice }],
        }));

        // Condition to add option on enter, (isMySpace)
        if (extraFieldData?.fieldId && !isAddMode) {
          handleFieldOptionAdd(extrafieldNewChoice);
        }

        setInputValue("");
      }
    }

    // Cycle to the next color only if a color_code is being added
    if ((isAddMode && isColorSelected) || (!isAddMode && isColoredEdit)) {
      const colorIndex = colors.indexOf(selectedColor);
      setSelectedColor(colorIndex + 1 === colors.length ? colors[0] : colors[colorIndex + 1]);
    }

    if (nameInputRef?.current) {
      nameInputRef.current.focus();
    }
  };

  // const handleField_options = () => {
  //   //fieldoptions
  //   if (choices.length > 0) {
  //     const newFieldOptions = choices.map((choice) => ({
  //       value: choice.name,
  //       code: choice.color,
  //     }));

  //     setExtraFieldData((prevState) => ({
  //       ...prevState,
  //       field_options: [...newFieldOptions],
  //     }));
  //   } else {
  //     console.error("No choices available to add.");
  //   }
  // };
  const handleInputEnter = () => {
    if (inputValue.trim()) {
      addChoice();
    }
  };

  // useEffect(() => {
  //   addChoice();
  // }, [extraFieldData?.field_options]);

  // const handleInputBlur = () => {
  //   if (inputValue) {
  //     addChoice();
  //   }
  // };

  const editClickOutside = useClickOutside(() => {
    if (editFieldOption !== null && !showPalette) {
      handleSaveEdit(editFieldOption);
      setEditFieldOption(null);
    }
  });

  const handleEditField = (index, field) => {
    setEditFieldOption(index);
    setEditValue({ ...field });
  };

  const handleSaveEdit = (index) => {
    const updatedFields = extraFieldData?.field_options?.map((field, i) => {
      if (i === index) {
        return {
          ...field,
          value: editValue.value,
          color_code: editValue.color_code,
        };
      }
      return field;
    });
    setExtraFieldData((prevState) => ({
      ...prevState,
      field_options: updatedFields,
    }));
    setEditFieldOption(null);
  };

  const handleDeleteOption = (index) => {
    const updatedOptions = extraFieldData?.field_options?.filter((_, i) => i !== index);
    console.log("Index to delete:", index);
    setExtraFieldData((prevState) => ({
      ...prevState,
      field_options: updatedOptions,
    }));
  };

  const handleAddNewField = () => {
    setInputVisible(true);
  };

  const handleDragStart = (index) => {
    //e.dataTransfer.setData("index", index);
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null) return;

    const field_optionsArr = extraFieldData?.field_options;
    const newField_options = [...field_optionsArr];
    const draggedItem = newField_options[draggedIndex];
    newField_options.splice(draggedIndex, 1);
    newField_options.splice(index, 0, draggedItem);
    setExtraFieldData((prevState) => ({
      ...prevState,
      field_options: newField_options,
    }));

    setDraggedIndex(null);
  };

  // useKeyboardShortcuts({
  //   Enter: (event) => {
  //     event.preventDefault();
  //     handleAddOption();
  //   },
  // });

  useEffect(() => {
    if (inputRef.current && editFieldOption !== null) {
      inputRef.current.focus();
    }
  }, [editFieldOption]);

  // Handle drag and drop
  const handleDragEnd = (result) => {
    alert(result);
    const { destination, source } = result;
    if (!result.destination) return;
    const reorderedChoices = Array.from(choices);
    const [movedItem] = reorderedChoices.splice(result.source.index, 1);
    reorderedChoices.splice(result.destination.index, 0, movedItem);
    setChoices(reorderedChoices);
  };

  // Remove choice
  const removeChoice = (id) => {
    const updatedFields = extraFieldData?.field_options.filter((_, i) => i !== id);

    setExtraFieldData((prevState) => ({
      ...prevState,
      field_options: updatedFields,
    }));

    // setChoices(choices.filter((choice) => choice.id !== id));
  };

  const handleEditChoice = (choice, index) => {
    setEditingChoiceId(index);
    setEditingChoiceValue(choice.value);
  };

  // const handleSaveEditChoice = (id) => {
  //   // Update the choices state with the new name
  //   const updatedChoices = extraFieldData?.field_options.map((choice, index) =>
  //     index === id ? { ...choice, value: editingChoiceValue } : choice
  //   );
  //   setExtraFieldData((previous) => ({ ...previous, field_options: updatedChoices }));
  //   console.log(updatedChoices, extraFieldData, "updatedChoices");

  //   // setChoices(updatedChoices);
  //   setEditingChoiceId(null);
  //   setEditingChoiceValue("");
  // };

  const handleSaveEditChoice = (id) => {
    console.log(editingChoiceValue, "5643435413541");

    if (editingChoiceValue.trim() === "") {
      dispatch(pushAlert({ type: "danger", message: "Choice name cannot be empty", visible: true }));
      return;
    }

    const trimmedValue = editingChoiceValue.trim().toLowerCase();

    const isDuplicate = extraFieldData?.field_options?.some(
      (choice, index) => index !== id && choice.value.trim().toLowerCase() === trimmedValue
    );

    if (isDuplicate) {
      dispatch(pushAlert({ type: "danger", message: "Choice already exists", visible: true }));
      return; // Stop execution if duplicate
    }

    const existingChoice = EditFieldData?.field_options[id];

    console.log(existingChoice, "EditFieldData6854", editingChoiceValue, selectedColor);
    if (existingChoice.value === editingChoiceValue && existingChoice.color_code === selectedColor) {
      setEditingChoiceId(null);
      setEditingChoiceValue("");
      return;
    }

    // Update the choices state with the new name
    const updatedChoices = extraFieldData?.field_options.map((choice, index) =>
      index === id ? { ...choice, value: editingChoiceValue, color_code: selectedColor } : choice
    );

    setExtraFieldData((previous) => ({ ...previous, field_options: updatedChoices }));
    setEditingChoiceId(null);
    setEditingChoiceValue("");

    // Condition to update option on enter, (isMySpace)
    if (extraFieldData?.fieldId) {
      handleFieldOptionUpdate(updatedChoices[id]);
    }
  };

  //
  // const handleColorChoice = () => {
  //   setIsColoredChoice(prev => !prev);
  //   console.log(extraFieldData, isColoredChoice, "iscoloredChoice");

  //   if (!isColoredChoice) {
  //     const resetcolorArr = extraFieldData?.field_options.map((choice) => ({
  //       ...choice,
  //       code: "#5F5E52",
  //     }));
  //     setExtraFieldData((previous) => ({ ...previous, field_options: resetcolorArr }));
  //   }
  // };

  // const handleColorChoice = () => {
  //   setIsColoredChoice((prev) => {
  //     const newState = !prev;
  //     setIsColorSelected(newState);
  //     console.log("New isColoredChoice:", newState);

  //     const updatedColors = extraFieldData?.field_options.map((choice, index) => ({
  //       ...choice,
  //       // color_code: newState ? `${colors[index % colors.length]}` : "",
  //     }));

  //     setExtraFieldData((previous) => ({ ...previous, field_options: updatedColors }));

  //     return newState;
  //   });
  // };

  const handleColorChoice = () => {
    setIsColoredChoice((prev) => {
      const newState = !prev;
      setIsColorSelected(newState);

      const updatedColors = extraFieldData?.field_options.map((choice, index) => {
        const updatedChoice = { ...choice };
        if (newState) {
          updatedChoice.color_code = colors[index % colors.length];
        } else {
          delete updatedChoice.color_code;
        }
        return updatedChoice;
      });

      setExtraFieldData((previous) => ({
        ...previous,
        field_options: updatedColors,
      }));

      return newState;
    });
  };

  const hanldeAddOptionClick = () => {
    handleAddNewField();
    handleInputEnter();
  };

  useEffect(() => {
    if (nameInputRef.current) {
      setTimeout(() => {
        nameInputRef.current.focus();
      }, 100);
      // nameInputRef.current.focus();
    }
  }, [extraFieldData.field_options.length]);

  useEffect(() => {
    if (listRef.current) {
      console.log(listRef.current, "listref");
      listRef.current.lastElementChild?.scrollIntoView({ behavior: "smooth" });
    }
  }, [extraFieldData.field_options.length]);

  useEffect(() => {
    if (editingChoiceValue.trim() === "") {
      setIsEmptyOption(false);
    } else {
      setIsEmptyOption(true);
    }
  }, [editingChoiceValue, setIsEmptyOption]);

  return (
    <div className="flex flex-col w-full grow min-h-0">
      {
        <div className=" bg-white  ">
          <h2 className="text-sm font-medium mb-2 flex items-center justify-between ">
            {/* <span className={`${Boolean(EditFieldData) ? "text-[#434852] opacity-50" : "text-[#434852]"} `}>
              {isTagsField ? <span className="text-[#434852] text-base">Tags</span> : "Choices"}
            </span> */}

            {!isTagsField && (
              <div className="flex items-center gap-3 mb-2 w-full justify-between">
                <h3
                  className={`${Boolean(EditFieldData) ? "text-primary-text-muted text-sm font-normal opacity-50" : "text-primary-text text-base font-normal "}`}
                >
                  Multi Select
                </h3>
                <div className={`items-center flex ${EditFieldData ? "opacity-50 pointer-events-none" : ""}`}>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={allowMultiple}
                      onChange={() => {
                        setAllowMultiple(!allowMultiple);
                        setSelectedDisplay("");
                      }}
                    />
                    <div
                      className={`w-10 h-6 mr-2 rounded-full transition relative ${
                        allowMultiple ? "bg-primary" : "bg-C0C0C0"
                      }`}
                    >
                      <div
                        className={`absolute top-1/2 transform -translate-y-1/2 transition-all ${
                          allowMultiple ? "right-1" : "left-1"
                        }`}
                      >
                        <Circle size={16} className="bg-white rounded-full text-white" />
                      </div>
                    </div>
                    <span className="font-14 font-400 text-1E1E1E">{allowMultiple ? "Yes" : "No"}</span>
                  </label>
                </div>
              </div>
            )}
            {/* hold by bhatiya sir every time choice with field*/}
            {/* {!isTagsField && ( 
              <div className={`relative ${EditFieldData ? "opacity-50 pointer-events-none" : ""}`}>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={EditFieldData ? isColoredEdit : isColoredChoice}
                    onChange={EditFieldData ? () => {} : handleColorChoice}
                  />
                  <ToolTipComponent text="Colored Choices">
                    <div
                      className={`w-12 h-6 rounded-full transition relative ${
                        (EditFieldData ? isColoredEdit : isColoredChoice) ? "bg-primary" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`absolute top-1/2 transform -translate-y-1/2 transition-all ${
                          (EditFieldData ? isColoredEdit : isColoredChoice) ? "right-1" : "left-1"
                        }`}
                      >
                        <Palette size={18} className="bg-white p-1 rounded-full text-gray-600" />
                      </div>
                    </div>
                  </ToolTipComponent>
                </label>
              </div>
            )} */}
          </h2>

          <span className={`${Boolean(EditFieldData) ? "text-primary-text" : "text-primary-text font-semibold"} `}>
            {isTagsField ? <span className="text-primary-text text-base">Tags</span> : "Choices"}
          </span>
        </div>
      }

      <div className="grow min-h-0 pb-[7%] gap-3 flex flex-col">
        <div ref={listRef} className={`max-h-full overflow-y-auto  thinscrollbar`}>
          {extraFieldData?.field_options.map((choice, index) => (
            <div
              key={choice.id}
              draggable
              tabIndex={0}
              onDragStart={() => handleDragStart(index)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDrop={(e) => handleDrop(e, index)}
              className="flex items-center justify-between py-2 cursor-grab mr-3"
              id={index}
              onBlur={(e) => {
                if (e.currentTarget.contains(e.relatedTarget)) return;

                if (editingChoiceId === index) {
                  if (editingChoiceValue.trim() === "") {
                    dispatch(
                      pushAlert({
                        type: "danger",
                        message: "Choice name cannot be empty",
                        visible: true,
                      })
                    );
                    setIsEmptyOption(true);

                    setTimeout(() => {
                      const input = e.currentTarget.querySelector("input");
                      if (input) input.focus();
                    }, 0);
                  } else {
                    handleSaveEditChoice(index);
                    setIsEmptyOption(false);
                  }
                }
              }}
            >
              <div className="flex items-center space-x-1">
                {/* Drag Handle */}
                <div className="text-gray-500">
                  <GripVertical size={18} />
                </div>

                {/* Choice Name Button */}
                {editingChoiceId === index ? (
                  <input
                    type="text"
                    className="px-4 py-1 rounded-full focus:outline-none"
                    style={{
                      backgroundColor: `${choice.color_code}33`,
                      color: choice.color_code,
                    }}
                    autoFocus={true}
                    value={editingChoiceValue}
                    onChange={(e) => setEditingChoiceValue(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        handleSaveEditChoice(index);
                      }
                    }}
                  />
                ) : (
                  <button
                    onClick={() => handleEditChoice(choice, index)}
                    className={`px-3 py-1 rounded-full font-normal text-sm`}
                    style={{
                      backgroundColor:
                        EditFieldData?.length > 0
                          ? isColoredEdit && choice.color_code
                            ? `${choice.color_code}33`
                            : ""
                          : isColoredChoice && choice.color_code
                            ? `${choice.color_code}33`
                            : "",
                      color:
                        EditFieldData?.length > 0
                          ? isColoredEdit && choice.color_code
                            ? `${choice.color_code}`
                            : "#383838"
                          : isColoredChoice && choice.color_code
                            ? `${choice.color_code}`
                            : "#383838",
                    }}
                  >
                    {choice.value}
                  </button>
                )}
              </div>

              <div className="flex items-center space-x-2">
                {/* Color Picker */}
                {isColoredChoice && (
                  <div className="relative ">
                    {(isAddMode || (isColoredEdit && choice.color_code)) && (
                      <button
                        onClick={() => {
                          handleColorpalette("code001", index);
                          handleEditChoice(choice, index);
                        }}
                      >
                        <i
                          className={`bi bi-palette-fill cursor-pointer`}
                          id={index}
                          style={{ color: choice.color_code }}
                        ></i>
                      </button>
                    )}
                    {showPalette && openPaletteId === index && colorpalette === "code001" && (
                      <FloatingList mode="vertical" xMargin={-100} margin={2} index={index}>
                        <div
                          className="fixed color-palette-panel grid grid-cols-4 rounded-md mt-[6px] -translate-x-12"
                          ref={colorcloseoutsideclick}
                        >
                          {colors.map((color, idx) => (
                            <div
                              key={idx}
                              className="color-box flex justify-center items-center w-full"
                              style={{
                                backgroundColor: color,
                                borderRadius: "3px",
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                                border: choice.color_code === color ? "2px solid black" : "none",
                              }}
                              onClick={() => handleColorClick(color, idx, index)}
                            ></div>
                          ))}
                        </div>
                      </FloatingList>
                    )}
                  </div>
                )}

                {/* Delete Button */}
                {choice?.id && removeChoiceApi && (
                  <button
                    className="ml-auto text-gray-500 cusror-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeChoiceApi(choice);
                    }}
                  >
                    <DeleteIcon />
                  </button>
                )}
                {!choice?.id && (
                  <button
                    className="ml-auto text-gray-500 cusror-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeChoice(index);
                    }}
                  >
                    <DeleteIcon />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className=" w-full " id="newField">
          {/* NEW fIELD WITH COLOR */}
          {InputVisible && (
            <div className="flex ">
              <div
                className="relative w-full"
                style={{
                  borderColor: "red",
                  color: "black",
                }}
              >
                <input
                  ref={nameInputRef}
                  className="w-full pl-2 rounded-md relative flex items-left justify-left border flex-1 mb-1 text-sm font-normal"
                  placeholder="Enter Name"
                  value={inputValue}
                  autoFocus={true}
                  onChange={handleInputChange}
                  /* onBlur={handleInputBlur} */
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      handleInputEnter();
                    }
                  }}
                />
                <div className="absolute right-0 top-0 bottom-0 flex items-center me-4 -mt-1">
                  {isColoredChoice && (
                    <div className="relative">
                      {(isAddMode || isColoredEdit) && (
                        <button
                          onClick={() => {
                            handleColorpalette("code001", 999);
                          }}
                        >
                          <i
                            className={`bi bi-palette-fill cursor-pointer mr-4 w-[29px] h-[26px] mb-1`}
                            // style={{ color: openPaletteId === 0 ? shadowColor : "#ee950f" }}
                            style={{ color: isColoredChoice ? `${selectedColor}` : "", shadowColor: "#ee950f" }}
                          ></i>
                        </button>
                      )}
                      {showPalette && openPaletteId == 999 && colorpalette === "code001" && (
                        <FloatingList mode="vertical" xMargin={-100} margin={2}>
                          <div
                            className="fixed color-palette-panel grid grid-cols-6 rounded-md  mt-[6px] -translate-x-12 "
                            ref={colorcloseoutsideclick}
                          >
                            {colors.map((color, idx, index) => (
                              <div
                                key={idx}
                                className="color-box flex justify-center items-center w-full "
                                style={{ backgroundColor: color, borderRadius: "4px", width: "20px", height: "20px" }}
                                onClick={() => handleColorClick(color, idx, index)}
                                // onClick={() => handleColorClick(color, choices.length + 1)}
                              ></div>
                            ))}
                          </div>
                        </FloatingList>
                      )}
                    </div>
                  )}
                  {/* <button onClick={handleAddOption}>
                  <i className="bi bi-arrow-right"></i>
                </button> */}
                </div>
              </div>
            </div>
          )}
          {addOptionEnabled && (
            <div className="flex justify-between items-center py-2">
              <button
                className="text-sm font-normal pl-2"
                // onClick={handleAddNewField}
                // onClick={handleInputEnter}
                disabled={isEmptyOption}
                onClick={hanldeAddOptionClick}
                style={{
                  // opacity: InputVisible ? 0.5 : 1,
                  fontWeight: InputVisible ? "400" : "500",
                  color: InputVisible ? "#2999BC" : "[#626262]",
                }}
              >
                Add Options<i className="bi bi-plus-square ml-3  mb-3"></i>
              </button>
              {false && (
                <button
                  className="flex items-center text-535252 px-3 py-1 text-sm"
                  onClick={() => setAddMore(!addMore)}
                >
                  <span className="mr-2">Add More</span>
                  {addMore ? <ChevronUp size={16} className="text-2999BC" /> : <ChevronDown size={16} />}
                </button>
              )}
            </div>
          )}
          {addMore && false && (
            <div className="p-4 mt-2 border-t border-b border-1d446933">
              <h3 className="text-434852 text-16 font-semibold mb-2">Allow Multiple Selections</h3>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={allowMultiple}
                  onChange={() => {
                    setAllowMultiple(!allowMultiple);
                    setSelectedDisplay("");
                  }}
                />
                <div className="w-10 h-6 mr-2 bg-C0C0C0 rounded-full peer-checked:bg-green-500 transition relative">
                  <div
                    className={`absolute top-1/2 transform -translate-y-1/2 transition-all ${
                      allowMultiple ? "right-1 text-gray-600" : "left-1 text-gray-600"
                    }`}
                  >
                    <Circle size={16} className="bg-white rounded-full text-white" />
                  </div>
                </div>
                <span className="text-base font-normal text-1E1E1E">{allowMultiple ? "Yes" : "No"}</span>
              </label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChoiceField;
